export default __webpack_public_path__ + "static/Contacto-b24d4c9a50d272d0b40e6eed6c6529ce.png";